import { Component, OnInit, inject } from '@angular/core';
import { OrderFacade } from 'src/app/store/order/facade';
import { ProblemForUserFacade } from 'src/app/store/problem-user/facade';
import { ProblemFacade } from 'src/app/store/problem/facade';
import { UrgencyFacade } from 'src/app/store/urgency/facade';
import { UserFacade } from 'src/app/store/user/facade';
import { SearchServiceFacade } from '../../../store/self-diagnostic/search-service/facade';
import { SelfDiagnosisFacade } from '../../../store/self-diagnostic/self-diagnosis/facade';
import { SelfDiagnosticStepFacade } from '../../../store/self-diagnostic/self-diagnostic-step/facade';
import { ServiceCatalogFacade } from '../../../store/self-diagnostic/service-catalog/facade';
import { TopServiceFacade } from '../../../store/self-diagnostic/top-service/facade';

@Component({
  selector: 'app-loading',
  templateUrl: './loading.component.html',
  styleUrls: ['./loading.component.scss'],
  standalone: false,
})
export class LoadingComponent implements OnInit {
  private userFacade = inject(UserFacade);
  private orderFacade = inject(OrderFacade);
  private problemFacade = inject(ProblemFacade);
  private problemForUserFacade = inject(ProblemForUserFacade);
  private searchServiceFacade = inject(SearchServiceFacade);
  private selfDiagnosisFacade = inject(SelfDiagnosisFacade);
  private selfDiagnosticStepFacade = inject(SelfDiagnosticStepFacade);
  private urgencyFacade = inject(UrgencyFacade);
  private serviceCatalogFacade = inject(ServiceCatalogFacade);
  private topServiceFacade = inject(TopServiceFacade);

  isLoading: boolean = true;

  isUserLoading: boolean = false;
  isOrderLoading: boolean = false;
  isProblemLoading: boolean = false;
  isProblemForUserLoading: boolean = false;
  isSearchServiceLoading: boolean = false;
  isSelfDiagnosisLoading: boolean = false;
  isSelfDiagnosticStepLoading: boolean = false;
  isUrgencyLoading: boolean = false;
  isServiceCatalogLoading: boolean = false;
  isTopServiceLoading: boolean = false;

  public ngOnInit(): void {
    this.userFacade.isLoading().subscribe(x => {
      this.isUserLoading = x;
      this.calcLoading();
    });

    this.orderFacade.isLoading().subscribe(x => {
      this.isOrderLoading = x;
      this.calcLoading();
    });

    this.problemFacade.isLoading().subscribe(x => {
      this.isProblemLoading = x;
      this.calcLoading();
    });

    this.problemForUserFacade.isLoading().subscribe(x => {
      this.isProblemForUserLoading = x;
      this.calcLoading();
    });

    this.searchServiceFacade.isLoading().subscribe(x => {
      this.isSearchServiceLoading = x;
      this.calcLoading();
    });

    this.selfDiagnosisFacade.isLoading().subscribe(x => {
      this.isSelfDiagnosisLoading = x;
      this.calcLoading();
    });

    this.selfDiagnosticStepFacade.isLoading().subscribe(x => {
      this.isSelfDiagnosticStepLoading = x;
      this.calcLoading();
    });

    this.urgencyFacade.isLoading().subscribe(x => {
      this.isUrgencyLoading = x;
      this.calcLoading();
    });

    this.serviceCatalogFacade.isLoading().subscribe(x => {
      this.isServiceCatalogLoading = x;
      this.calcLoading();
    });

    this.topServiceFacade.isLoading().subscribe(x => {
      this.isTopServiceLoading = x;
      this.calcLoading();
    });
  }

  private calcLoading() {
    this.isLoading =
      this.isUserLoading ||
      this.isOrderLoading ||
      this.isProblemLoading ||
      this.isProblemForUserLoading ||
      this.isSearchServiceLoading ||
      this.isSelfDiagnosisLoading ||
      this.isSelfDiagnosticStepLoading ||
      this.isUserLoading ||
      this.isServiceCatalogLoading ||
      this.isTopServiceLoading;
  }
}
